import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';
import Reveal from '@/components/base/Reveal';

export default function FirmStatement() {
  return (
    <section id="the-firm" className="bg-white py-20 md:py-28 lg:py-32">
      <Container>
        <SectionLabel index="01" label="The Firm" />
        <div className="mt-12 grid grid-cols-1 gap-10 md:mt-20 lg:grid-cols-12 lg:gap-6">
          <Reveal className="lg:col-span-8">
            <h2 className="font-heading text-[44px] font-light leading-[1.02] tracking-[-0.025em] text-foreground-950 md:text-[64px] lg:text-[72px]">
              Clarity in every<br />
              decision<span className="text-primary-500">.</span>
            </h2>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-4 lg:border-l lg:border-background-200 lg:pl-8">
            <p className="text-[15px] leading-[1.7] text-foreground-800 md:text-base">
              AVENOR is an independent accounting and advisory practice. We work with owner-led businesses,
              organisations and private clients who value <strong className="font-medium text-foreground-950">accuracy, discretion and a clear line of reasoning</strong> behind every recommendation.
            </p>
            <p className="mt-5 text-[15px] leading-[1.7] text-foreground-700 md:text-base">
              Each client works directly with a partner, supported by a small team that knows their affairs well.
            </p>
            <Link to="/people" className="ed-link mt-8 inline-block cursor-pointer whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950">
              Meet the partners
            </Link>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}